import {getLabel} from '../../../../../../@casino/lib/getLabel';
import {getDate} from '../../../../../../@casino/lib/getDate';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {parseLogin} from '../../../../../../@casino/lib/parseLogin';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20, paddingTop: 0, color: '#fff'
    },
    wrap: {
        padding: 0, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12
    },
    wrapBlock: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12
    },
    search: {
        padding: 10,
        background: '#141b33',
        paddingLeft: 10,
        border: '1px solid #141b33',
        color: '#fff',
        outline: 'none',
        margin: 10,
        width: '97.3%'
    },
    wrapSwitch: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165,
    },
    manually: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165, 
        color: '#fff'
    },
    spo: {
        width: 40, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        background: '#141b33',
        color: '#fff',
        boxShadow: '4px 4px 8px 0px rgb(34 60 80 / 20%)',
    },
    datetime: {
        border: 'none', 
        outline: 'none', 
        paddingLeft: 15, 
        borderRadius: 4, 
        background: '#34488c',
        color: '#fff'
    },
}));

const columns = [
    { id: 'id', label: 'ID'},
    { id: 'login', label: 'Логин'},
    { id: 'bonus_name', label: 'Название бонуса'},
    { id: 'bonus_label', label: 'Бонус'},
    { id: 'amount', label: 'Сумма'},
    { id: 'date_event', label: 'Дата/время'},
    { id: 'cause', label: 'Причина'}
];

const getRows = (bonusesHistory) => {
    return bonusesHistory.data.map((item) => {
        return {
            id: item.id,
            login: parseLogin(item.login),
            bonus_name: item.bonus_name ? item.bonus_name : '-',
            bonus_label: item.bonus_label ? getLabel(item.bonus_label) : '-',
            amount: item.amount ? new Intl.NumberFormat('ru-RU').format(item.amount) + '₽' : 0,
            date_event: getDate(item.date_event),
            cause: item.cause ? item.cause : '-'
        }
    })
}

export {
    useStyles,
    columns,
    getRows
}